import React from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.iconContainer}>
          <span style={styles.icon}>❌</span>
        </div>
        <h1 style={styles.title}>Payment Cancelled</h1>
        <p style={styles.message}>
          Your payment was cancelled. No charges were made.
        </p>
        <div style={styles.actions}>
          <button
            style={styles.primaryButton}
            onClick={() => navigate('/upgrade')}
          >
            Try Again
          </button>
          <button
            style={styles.secondaryButton}
            onClick={() => navigate('/dashboard')}
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: 'var(--bg-base)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
  },
  card: {
    backgroundColor: 'var(--bg-elevated)',
    borderRadius: '20px',
    padding: '48px',
    textAlign: 'center',
    maxWidth: '500px',
    border: '1px solid var(--border-light)',
  },
  iconContainer: {
    marginBottom: '24px',
  },
  icon: {
    fontSize: '64px',
  },
  title: {
    fontSize: '32px',
    fontWeight: '700',
    color: 'var(--text-primary)',
    marginBottom: '16px',
  },
  message: {
    fontSize: '18px',
    color: 'var(--text-secondary)',
    marginBottom: '32px',
    lineHeight: '1.6',
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  primaryButton: {
    background: 'var(--gradient-primary)',
    color: 'var(--text-primary)',
    padding: '14px 32px',
    borderRadius: '10px',
    border: 'none',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  secondaryButton: {
    backgroundColor: 'transparent',
    color: 'var(--text-secondary)',
    padding: '12px 32px',
    borderRadius: '10px',
    border: '1px solid var(--border-light)',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
  },
};

export default PaymentCancel;
